import api from "!../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../node_modules/css-loader/dist/cjs.js??ref--5-oneOf-4-1!../../node_modules/postcss-loader/src/index.js??postcss!./index.css";

var options = {};

options.insert = function(linkTag) {
  document.getElementById('mayaChatWidget').shadowRoot.appendChild(linkTag)
};
options.singleton = false;

var update = api(content, options);



export default content.locals || {};